<template>

    <el-card>
        <div class="announcement-header">
            <div class="announcement-icon">
                <i class="el-icon-location-outline"></i>
            </div>
            <div class="announcement-title">农残检测</div>
        </div>
        <div class="device-table-container">
            <div class="checkin-overview-list">
                <div class="overview-header">
                    <div class="header-item">食材名称</div>
                    <div class="header-item">食材类别</div>
                    <div class="header-item">批次编号</div>
                    <div class="header-item">供应商</div>
                    <div class="header-item">检测农药</div>
                    <div class="header-item">检测值(mg/kg)</div>
                    <div class="header-item">标准值(mg/kg)</div>
                    <div class="header-item">检测日期</div>
                    <div class="header-item">检测人员</div>
                    <div class="header-item">检测状态</div>
                </div>
                <!-- 滚动列表的视窗容器 -->
                <div class="marquee-container">
                    <div class="overview-body">
                        <div class="overview-row" v-for="(item, index) in tableData" :key="index">
                            <div class="body-item">{{ item.materialName }}</div>
                            <div class="body-item"> {{ item.category === 'vegetable' ? '蔬菜类' :
                                item.category === 'fruit' ? '水果类' :
                                    item.category === 'grain' ? '粮油类' :
                                        item.category === 'meat' ? '肉类' : '水产类' }}</div>
                            <div class="body-item">{{ item.batchNo }}</div>
                            <div class="body-item"> {{ item.supplier }}</div>

                            <div class="body-item"> {{ item.pesticideName }}</div>
                            <div class="body-item"> {{ item.detectionValue }}</div>
                            <div class="body-item"> {{ item.standardValue }}</div>
                            <div class="body-item"> {{ item.detectionDate }}</div>

                            <div class="body-item"> {{ item.detector }}</div>
                            <div class="body-item">

                                <el-tag
                                    :type="item.status === 'qualified' ? 'success' : (item.status === 'exceed' ? 'danger' : 'warning')">
                                    {{ item.status === 'qualified' ? '合格' : (item.status === 'exceed' ? '超标' : '待检测')
                                    }}
                                </el-tag>
                            </div>

                        </div>
                        <div class="empty-tip" v-if="tableData.length === 0">
                            暂无数据
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </el-card>
</template>

<script>
export default {

    data() {
        return {
            // 搜索表单
            searchForm: {
                materialName: '',
                detectionDate: '',
                status: ''
            },

            // 表格数据
            tableData: [],
            // 新增：缓存全量原始数据
            allTableData: [],
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            selectedRows: [],

            // 统计数据
            weekTotal: 128,
            qualifiedRate: 92,
            exceedCount: 8,
            pendingCount: 15,

            // 弹窗控制
            detailVisible: false,
            formVisible: false,

            // 详情数据
            detailData: {},

            // 表单数据
            formData: {
                materialName: '',
                category: '',
                batchNo: '',
                supplier: '',
                supplierContact: '',
                pesticideName: '',
                detectionValue: '',
                standardValue: '',
                detectionDate: '',
                detector: '',
                device: '',
                status: 'pending',
                remark: ''
            },


        }
    },
    mounted() {
        this.loadTableData();
    },
    methods: {
        // 加载表格数据
        loadTableData() {
            // 模拟接口请求
            const mockData = [
                {
                    id: '1',
                    materialName: '小白菜',
                    category: 'vegetable',
                    batchNo: '20231021001',
                    supplier: '绿源蔬菜基地',
                    supplierContact: '13800138000',
                    pesticideName: '毒死蜱',
                    detectionValue: 0.02,
                    standardValue: 0.1,
                    detectionDate: '2023-10-21',
                    detector: '杨继起',
                    device: '农残快速检测仪 model-2023',
                    status: 'qualified',
                    remark: '正常检测'
                },
                {
                    id: '2',
                    materialName: '苹果',
                    category: 'fruit',
                    batchNo: '20231021002',
                    supplier: '红星果业',
                    supplierContact: '13900139000',
                    pesticideName: '百菌清',
                    detectionValue: 0.5,
                    standardValue: 0.3,
                    detectionDate: '2023-10-21',
                    detector: '杨如意',
                    device: '农残快速检测仪 model-2023',
                    status: 'exceed',
                    remark: '检测值超标'
                },
                {
                    id: '3',
                    materialName: '西红柿',
                    category: 'vegetable',
                    batchNo: '20231021003',
                    supplier: '绿源蔬菜基地',
                    supplierContact: '13800138000',
                    pesticideName: '多菌灵',
                    detectionValue: 0.05,
                    standardValue: 0.2,
                    detectionDate: '2023-10-21',
                    detector: '陈鸿宇',
                    device: '农残快速检测仪 model-2023',
                    status: 'qualified',
                    remark: ''
                },
                {
                    id: '4',
                    materialName: '黄瓜',
                    category: 'vegetable',
                    batchNo: '20231020001',
                    supplier: '青田蔬菜合作社',
                    supplierContact: '13700137000',
                    pesticideName: '克百威',
                    detectionValue: '',
                    standardValue: 0.02,
                    detectionDate: '2023-10-20',
                    detector: '刘宇',
                    device: '',
                    status: 'pending',
                    remark: '待检测'
                },
                {
                    id: '5', // 修正：原ID重复问题
                    materialName: '西红柿',
                    category: 'vegetable',
                    batchNo: '20231020001',
                    supplier: '青田蔬菜合作社',
                    supplierContact: '13700137000',
                    pesticideName: '克百威',
                    detectionValue: '',
                    standardValue: 0.02,
                    detectionDate: '2023-10-20',
                    detector: '王硕',
                    device: '',
                    status: 'pending',
                    remark: '待检测'
                },
                {
                    id: '6', // 修正：原ID重复问题
                    materialName: '茄子',
                    category: 'vegetable',
                    batchNo: '20231020001',
                    supplier: '青田蔬菜合作社',
                    supplierContact: '13700137000',
                    pesticideName: '多菌灵',
                    detectionValue: '',
                    standardValue: 0.02,
                    detectionDate: '2023-10-20',
                    detector: '刘宇',
                    device: '',
                    status: 'pending',
                    remark: '待检测'
                }
            ];

            // 修改：缓存全量数据
            this.allTableData = mockData;
            // 初始化时执行过滤（显示全部数据）
            this.filterTableData();
        },

        // 新增：前端过滤表格数据
        filterTableData() {
            // 从全量数据拷贝，避免修改原数据
            let filteredData = [...this.allTableData];

            // 1. 按食材名称过滤（模糊匹配，忽略大小写）
            if (this.searchForm.materialName) {
                const keyword = this.searchForm.materialName.trim().toLowerCase();
                filteredData = filteredData.filter(item =>
                    item.materialName && item.materialName.toLowerCase().includes(keyword)
                );
            }

            // 2. 按检测日期过滤（精确匹配）
            if (this.searchForm.detectionDate) {
                filteredData = filteredData.filter(item =>
                    item.detectionDate === this.searchForm.detectionDate
                );
            }

            // 3. 按检测状态过滤
            if (this.searchForm.status) {
                filteredData = filteredData.filter(item =>
                    item.status === this.searchForm.status
                );
            }

            // 更新总条数
            this.totalCount = filteredData.length;

            // 分页处理
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            this.tableData = filteredData.slice(start, end);
        },




        // 选择行变化
        handleSelectionChange(rows) {
            this.selectedRows = rows;
        },



        // 新增（补充：原代码缺少handleAdd方法调用，这里完善）
        handleAdd() {
            this.formData = {
                materialName: '',
                category: '',
                batchNo: '',
                supplier: '',
                supplierContact: '',
                pesticideName: '',
                detectionValue: '',
                standardValue: '',
                detectionDate: '',
                detector: '',
                device: '',
                status: 'pending',
                remark: ''
            };
            this.formVisible = true;
        },


    }
}
</script>

<style lang="scss" scoped>
.announcement-header {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    padding: 10px 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 15px;

    .announcement-icon {
        color: #faad14;
        font-size: 20px;
        margin-right: 10px;
    }
}

.device-table-container {
    display: flex;
    flex-direction: column;
    height: calc(100% - 60px);
    overflow: hidden;
}

// --- 自动滚动列表样式 ---
.checkin-overview-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .overview-header {
        display: flex;
        background-color: #f8f9fa;
        font-weight: 600;
        padding: 12px 0;
        border-bottom: 1px solid #e8e8e8;
        z-index: 10;

        .header-item {
            flex: 1;
            text-align: center;
            color: #333;
        }
    }

    .marquee-container {
        flex: 1;
        overflow: hidden;
    }

    .overview-body {
        animation: scroll-up-device-table 60s linear infinite;
        height: 100%;

        &:hover {
            animation-play-state: paused;
        }

        .overview-row {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px dashed #f0f0f0;

            &:hover {
                background-color: #f8f9fa;
            }

            .body-item {
                flex: 1;
                text-align: center;
                color: #666;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .empty-tip {
            text-align: center;
            padding: 50px 0;
            color: #999;
        }
    }
}

// 设备列表滚动动画
@keyframes scroll-up-device-table {
    0% {
        transform: translateY(0);
    }

    100% {
        transform: translateY(calc(-100% + 30vh));
    }
}
</style>